import { Trans } from "@lingui/macro";
import { ethers } from "ethers";

import { BESC } from "config/chains";
import { USD_DECIMALS } from "config/factors";
import { useV1FeesInfo } from "domain/stats";
import { useVolumeData } from "domain/legacy";
import useUniqueUsers from "domain/stats/useUniqueUsers";
import { formatAmount } from "lib/numbers";
import type { ChainStats } from "./useDashboardChainStatsMulticall";

import StatsTooltipRow from "components/StatsTooltip/StatsTooltipRow";
import TooltipComponent from "components/Tooltip/Tooltip";

export function StatsCard({ statsBesc }: { statsBesc?: ChainStats }) {
  const [totalVolume, totalVolumeDelta] = useVolumeData();
  const v1Fees = useV1FeesInfo(BESC);
  const uniqueUsers = useUniqueUsers();

  const totalFeesUsd = v1Fees?.totalFees;
  const totalUniqueUsers = uniqueUsers?.[BESC] ?? 0n;

  return (
    <div className="App-card">
      <div className="App-card-title">
        <Trans>Stats</Trans>
      </div>
      <div className="App-card-divider"></div>
      <div className="App-card-content">
        <div className="App-card-row">
          <div className="label">
            <Trans>Fees</Trans>
          </div>
          <div>
            <TooltipComponent
              position="bottom-end"
              className="whitespace-nowrap"
              handle={`$${formatAmount(totalFeesUsd, USD_DECIMALS, 0, true)}`}
              content={<StatsTooltipRow label="BESC Hyperchain" value={formatAmount(totalFeesUsd, USD_DECIMALS, 0, true)} />}
            />
          </div>
        </div>
        <div className="App-card-row">
          <div className="label">
            <Trans>Volume</Trans>
          </div>
          <div>
            <TooltipComponent
              position="bottom-end"
              className="whitespace-nowrap"
              handle={`$${totalVolume ? totalVolume?.toFixed(2) : 0}`}
              content={
                <StatsTooltipRow
                  label="BESC Hyperchain"
                  value={formatAmount(
                    ethers.parseUnits((totalVolume ?? 0).toString(), USD_DECIMALS),
                    USD_DECIMALS,
                    2,
                    true
                  )}
                />
              }
            />
          </div>
        </div>
        <div className="App-card-row">
          <div className="label">
            <Trans>Users</Trans>
          </div>
          <div>
            <TooltipComponent
              position="bottom-end"
              className="whitespace-nowrap"
              handle={formatAmount(totalUniqueUsers, 0, 0, true)}
              content={<StatsTooltipRow label="BESC Hyperchain" value={formatAmount(totalUniqueUsers, 0, 0, true)} showDollar={false} />}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
